module.exports = __webpack_public_path__ + "static/media/8.61824dce.jpg";